import { reactive } from 'vue'

const dialogState = reactive({
  visible: false,
  title: '',
  message: '',
  alertOnly: false,
  onConfirm: null,
  onCancel: null
})

export function useDialog() {
    let alertTimeout = null

    const alert = ({ title, message, onCancel }) => {
      clearTimeout(alertTimeout)
    
      Object.assign(dialogState, {
        title,
        message,
        alertOnly: true,
        visible: true,
        onConfirm: null,
        onCancel: onCancel || (() => {})
      })
    
      // Default timeout of 2000ms
      alertTimeout = setTimeout(() => {
        dialogState.visible = false
        dialogState.onCancel && dialogState.onCancel()
      }, 2000)
    }

  const confirm = ({ title, message, onConfirm, onCancel }) => {
    Object.assign(dialogState, {
      title,
      message,
      alertOnly: false,
      visible: true,
      onConfirm,
      onCancel
    })
  }

  return {
    dialogState,
    alert,
    confirm
  }
}
